<template>
	<div class="header">
		<!-- <iframe id="receiver" :src="'http://localhost:8000/adm/manage/center'" width="500" style="display:none">
      <p>你的浏览器不支持IFrame。</p>
    </iframe> -->
		<div class="header_title">
			<img src="/static/img/yun.png" alt="" />
			<span>{{ areaNameTitle }}</span>
		</div>
		<!-- <div class="nav">
			<div :class="[{ active: activeName === item.text }]" v-for="(item, index) in navList" :key="index" @click="navClick(item)">
				<img :src="item.img" alt="" />
				<span>{{ item.text }}</span>
			</div>
		</div> -->
		<el-menu :default-active="selectIndex" router mode="horizontal" @select="handleSelect">
			<div :class="nav_class">
				<div :class="[{ active: activeName === item.text },'nav_items'+item.id]" v-for="(item, index) in navList" :key="index" @click="navClick(item)">
					<el-menu-item :index="item.url">
						<!-- <img :src="item.img" alt="" class="header-icon"> -->
						<span>{{item.text}}</span>
					</el-menu-item>
				</div>
			</div>
		</el-menu>
		<div class="header_right">
			<!-- <div class="areaName">
				<img src="/static/img/dingwei.png" alt="" />
				<span>{{ areaName }}</span>
			</div> -->
			<div class="goadmin" @click="goadmin" style="cursor: pointer;">
				<p style="line-height: none;"><img src="/static/img/gongzuotai.png" alt="" /></p>
				<span style="display:inline-block;">工作台</span>
			</div>
			<div class="goadmin" @click="loginOut" style="cursor: pointer;">
				<p style="line-height: none;"><img src="/static/img/head/exit_icon.png" alt="" /></p>
				<span style="display:inline-block;">退出</span>
			</div>
			<!-- <div class="loginOut">
				<img src="/static/img/touxiang.png" alt="" />
				<el-dropdown @command="loginOut">
					<span class="el-dropdown-link">
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item icon="el-icon-switch-button">退出登录</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</div> -->
		</div>
		<el-dialog title="提示" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
			<span>确定退出登录吗？</span>
			<span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="authLogout">确 定</el-button>
      </span>
		</el-dialog>
	</div>
</template>
<script>
import Api from "../../../Serves/net-api.js";
import Http from "../../../Serves/net-http.js";
import { mapState, mapActions, mapMutations } from "vuex";
export default {
  computed: {},
  data() {
    return {
      activeName: "农机大数据",
      selectIndex: "/",
      navList: [],
      areaName: "",
      areaNameTitle: '',
      dialogVisible: false,
      nav_class: ''
    };
  },
  computed: {
    info() {
      return this.$store.state.info;
    },
  },
  mounted() {
    // this.activeName = sessionStorage.getItem('navClickVal')
    console.log("84userInfo", JSON.parse(localStorage.getItem("userInfo")))
    const userInfo = localStorage.getItem("userInfo") ? JSON.parse(localStorage.getItem("userInfo")) : null; 
    if (userInfo && userInfo.loginName == "bjview") {
      this.activeName = "农机三合一"
    } else {
      if(window.location.pathname === "/view/" || window.location.pathname === "/view") { // 农机大数据
        this.activeName = "农机大数据"
      } else if(this.$store.state.active === '/positioning-monitor') {
        this.activeName = "农机三合一"
      } else if(this.$store.state.active === '/subsidie-monitor') {
        this.activeName = "应用补贴"
      } else if(this.$store.state.active === '/DiscountSubsidy') {
        this.activeName = "作业补贴机具"
      } else if(this.$store.state.active === '/DiscountSubsidy') {
        this.activeName = "贷款贴息监管"
      } else if(this.$store.state.active === '/MachineryStock') {
        this.activeName = "减排农机"
      } else {
        this.activeName = "农机大数据"
      }
    }
    // 获取/设置头部地区名称
    var host = window.location.host;
    this.$nextTick(() => {
      this.areaName = userInfo&&userInfo.areaName?userInfo.areaName:"";
      let govLevel = userInfo&&userInfo.govLevel?userInfo.govLevel:"";
      var title = '农机物联网云平台'
      if(host.indexOf('huaxia') > -1 && govLevel == 1) {
        this.areaNameTitle = '华夏省' + title;
      } else {
        this.areaNameTitle = this.areaName + title;
      }
    })
    this.getNavList()
  },
  methods: {
    getNavList() {
      var host = window.location.host
      if(host === 'jiangsu.dtwl360.com' || host === 'huaxia.dtwl360.com') {
        this.nav_class = 'nav'
        this.navList = [
          {
            text: "农机大数据",
            id: 0,
            url: "/"
          },
          {
            text: "农机三合一",
            id: 1,
            url: "/positioning-monitor"
          }
        ]
      } else if(host === 'hunan.dtwl360.com') {
        this.nav_class = 'nav_hunan'
        this.navList = [
          {
            text: "农机大数据",
            url: "/",
            id: 0
          },
          {
            text: "农机三合一",
            url: "/positioning-monitor",
            id: 1
          },
          {
            text: "应用补贴",
            url: '/subsidie-monitor',
            id: 2,
          },
          {
            text: "作业补贴机具",
            url: '/JobSubsidy',
            id: 5
          }
        ]
      } else if(host === 'hebei.dtwl360.com') {
        this.nav_class = 'nav_hunan'
        this.navList = [
          {
            text: "农机大数据",
            url: "/",
            id: 0
          },
          {
            text: "农机三合一",
            url: "/positioning-monitor",
            id: 1
          },
          {
            text: "应用补贴",
            url: '/subsidie-monitor',
            id: 2,
          },
          {
            text: "贷款贴息监管",
            url: '/DiscountSubsidy',
            id: 3
          }
        ]
      } else if(host === 'beijing.dtwl360.com') {
        this.nav_class = 'nav_hunan'
        // console.log(this.$store.state.info.loginName)
        if (this.$store.state.info.loginName == "bjview") {
          this.navList = [
            {
              text: "农机三合一",
              url: "/positioning-monitor",
              id: 1
            }
          ]
        } else {
          this.navList = [{
              text: "农机大数据",
              url: "/",
              id: 0
            },
            {
              text: "农机三合一",
              url: "/positioning-monitor",
              id: 1
            },
            {
              text: "减排农机",
              url: '/MachineryStock',
              id: 4,
            }
          ]
        }
      } else if(host === 'bdh.dtwl360.com' || host === 'xinjiang.dtwl360.com' || host === 'xjbt.dtwl360.com' || host == 'localhost:8081') { // 北大荒，新疆，新疆兵团
        this.nav_class = 'nav_hunan'
        this.navList = [{
            text: "农机大数据",
            url: "/",
            id: 0
          },
          {
            text: "农机三合一",
            url: "/positioning-monitor",
            id: 1
          },
          {
            text: "应用补贴",
            url: '/subsidie-monitor',
            id: 2,
          }
        ]
      } else {
        this.nav_class = 'nav'
        this.navList = [{
            text: "农机大数据",
            id: 0,
            url: "/"
          },
          {
            text: "农机三合一",
            id: 1,
            url: "/positioning-monitor"
          }
        ]
      }
    },
    // 获取/设置头部地区名称
    getAreaName() {
      var host = window.location.host
      let this_ = this;
      // this.$nextTick(() => {
      // 	setTimeout(() => {
          // this_.areaName = this_.$store.state.info.areaName
          this_.areaName = this_.$store.state.areaName
          let govLevel = this_.$store.state.info.govLevel
          var title = '农机物联网云平台'
          // this_.areaNameTitle = this_.areaName + title
          if(host.indexOf('huaxia') > -1 && govLevel == 1) {
            this_.areaNameTitle = '华夏省' + title
          } else {
            this_.areaNameTitle = this_.areaName + title
          }
          //      if(host === 'beijing.dtwl360.com') {
          //        this_.areaNameTitle = '北京市' + title
          //      } else if(host === 'hunan.dtwl360.com') {
          //        this_.areaNameTitle = '湖南省' + title
          //      } else if(host === 'hebei.dtwl360.com') {
          //        this_.areaNameTitle = '河北省' + title
          //      } else if(host === 'neimeng.dtwl360.com') {
          //        this_.areaNameTitle = '内蒙古' + title
          //      } else if(host === 'xiamen.dtwl360.com') {
          //        this_.areaNameTitle = '厦门市' + title
          //      } else if(host === 'hubei.dtwl360.com') {
          //        this_.areaNameTitle = '湖北省' + title
          //      } else if(host === 'ningbo.dtwl360.com') {
          //        this_.areaNameTitle = '宁波市' + title
          //      } else if(host === 'gansu.dtwl360.com') {
          //        this_.areaNameTitle = '甘肃省' + title
          //      } else if(host === 'qinghai.dtwl360.com') {
          //        this_.areaNameTitle = '青海省' + title
          //      } else if(host === 'bdh.dtwl360.com') {
          //        this_.areaNameTitle = '北大荒农垦集团' + title
          //      } else if(host === 'anhui.dtwl360.com') {
          //        this_.areaNameTitle = '安徽省' + title
          //      } else if(host === 'jiangsu.dtwl360.com') {
          //        //this_.areaNameTitle = '江苏省' + title
          //        if(this_.$store.state.info.govLevel == 1) {
          //						this_.areaNameTitle = '江苏省' + title
          //					} else if(this_.$store.state.info.govLevel == 2) {
          //						this_.areaNameTitle = '无锡市' + title
          //					} else {
          //						this_.areaNameTitle = '无锡市锡山区' + title
          //					}
          //      } else if(host === 'xjbt.dtwl360.com') {
          //        this_.areaNameTitle = '新疆兵团' + title
          //      } else if(host === 'xinjiang.dtwl360.com') {
          //        this_.areaNameTitle = '新疆' + title
          //      } else if(host === 'guangdong.dtwl360.com') {
          //        this_.areaNameTitle = '广东省' + title
          //      } else if(host === 'qingdao.dtwl360.com') {
          //        this_.areaNameTitle = '青岛市' + title
          //      } else if(host === 'jiangxi.dtwl360.com') {
          //        this_.areaNameTitle = '江西省' + title
          //      } else if(host === 'shandong.dtwl360.com') {
          //        this_.areaNameTitle = '山东省' + title
          //      } else if(host === 'ningxia.dtwl360.com') {
          //        this_.areaNameTitle = '宁夏' + title
          //      } else if(host === 'chongqing.dtwl360.com') {
          //        this_.areaNameTitle = '重庆市' + title
          //      } else if(host === 'fujian.dtwl360.com') {
          //        this_.areaNameTitle = '福建省' + title
          //      } else if(host === 'zhejiang.dtwl360.com') {
          //        this_.areaNameTitle = '浙江省' + title
          //      } else if(host === 'tianjin.dtwl360.com') {
          //        this_.areaNameTitle = '天津市' + title
          //      } else if(host === 'guangxi.dtwl360.com') {
          //        this_.areaNameTitle = '广西' + title
          //      } else if(host === 'taiwan.dtwl360.com') {
          //        this_.areaNameTitle = '台湾省' + title
          //      } else if(host === 'henan.dtwl360.com') {
          //        this_.areaNameTitle = '河南省' + title
          //      } else if(host === 'national.dtwl360.com') {
          //        this_.areaNameTitle = '全国' + title
          //      } else if (host === 'sichuan.dtwl360.com') {
          //        this_.areaNameTitle = '四川省' + title
          //      } else {
          //        //this_.areaNameTitle = '江苏省' + title
          //        if(this_.$store.state.info.govLevel == 1) {
          //						this_.areaNameTitle = '江苏省' + title
          //					} else if(this_.$store.state.info.govLevel == 2) {
          //						this_.areaNameTitle = '无锡市' + title
          //					} else {
          //						this_.areaNameTitle = '无锡市锡山区' + title
          //					}
          //      }
        // }, 800)
      // })
    },
    handleSelect(key, keyPath) {
      this.selectIndex = key;
      this.selectInit(key);
      this.$store.commit('active', key);
    },
    selectInit(key) {
      this.navList = this.navList.map((e) => {
        if(key == e.url) {
          e.active = true;
        } else {
          e.active = false;
        }
        return e;
      })
    },
    // 头部菜单切换
    navClick(item) {
      this.$store.commit('discountData', [])
      this.$store.commit('SpanningAreaData', [])
      this.$store.commit('WarningData', [])
      this.$store.commit('toolWorkRankData', [])
      var host = window.location.host
      this.warnSum = ''
      this.activeName = item.text
      sessionStorage.setItem('navClickVal', item.text)
      if(item.id === 1) { // 三合一管理
        this.$router.push("/positioning-monitor")
      } else if(item.id === 0) { // 农机大数据
        this.$router.push("/")
      } else if(item.id === 2) { // 应用补贴
        this.$router.push({
          path: "/subsidie-monitor"
        })
      } else if(item.id === 3) { // 贷款贴息监管
        this.$router.push("/DiscountSubsidy")
      } else if(item.id === 4) { // 减排农机
        this.$router.push("/MachineryStock")
      } else if(item.id === 5) { // 作业补贴机具
        this.$router.push("/JobSubsidy")
      }
    },
    loginOut() {
      this.dialogVisible = true
    },
    authLogout() {
      var url = Http.test + "/logout"
      Api.doPost(url, null, false, res => {
        localStorage.clear()
        sessionStorage.clear()
        var myDate = new Date()
        var tYear = myDate.getFullYear()
        this.$store.commit("Year", tYear)
        this.$store.commit("active", "/")
        if(window.location.host === 'beijing.dtwl360.com') {
          window.location.href = 'https://beijing.dtwl360.com/adm/user/login'
        } else if(window.location.host === 'chongqing.dtwl360.com') {
          window.location.href = 'https://chongqing.dtwl360.com/adm/user/login'
        } else if(window.location.host === 'fujian.dtwl360.com') {
          window.location.href = 'https://fujian.dtwl360.com/adm/user/login'
        } else if(window.location.host === 'henan.dtwl360.com') {
          window.location.href = 'https://henan.dtwl360.com/adm/user/login'
        } else if(window.location.host === 'taiwan.dtwl360.com') {
          window.location.href = 'https://taiwan.dtwl360.com/adm/user/login'
        } else if(window.location.host === 'shandong.dtwl360.com') {
          window.location.href = 'https://shandong.dtwl360.com/adm/user/login'
        } else if(window.location.host === 'xjbt.dtwl360.com') {
          window.location.href = 'https://xjbt.dtwl360.com/adm/user/login'
        } else if(window.location.host === 'ningxia.dtwl360.com') {
          window.location.href = 'https://ningxia.dtwl360.com/adm/user/login'
        } else if(window.location.host === 'qingdao.dtwl360.com') {
          window.location.href = 'https://qingdao.dtwl360.com/adm/user/login'
        } else if(window.location.host === 'jiangxi.dtwl360.com') {
          window.location.href = 'https://jiangxi.dtwl360.com/adm/user/login'
        } else if(window.location.host === 'hunan.dtwl360.com') {
          window.location.href = 'https://hunan.dtwl360.com/adm/user/login'
        } else if(window.location.host === 'hebei.dtwl360.com') {
          window.location.href = 'https://hebei.dtwl360.com/adm/user/login'
        } else if(window.location.host === 'gansu.dtwl360.com') {
          window.location.href = 'https://gansu.dtwl360.com/adm/user/login'
        } else if(window.location.host === 'national.dtwl360.com') {
          window.location.href = 'https://national.dtwl360.com/adm/user/login'
        } else if(window.location.host === 'neimeng.dtwl360.com') {
          window.location.href = 'https://neimeng.dtwl360.com/adm/user/login'
        } else if(window.location.host === 'xiamen.dtwl360.com') {
          window.location.href = 'https://xiamen.dtwl360.com/adm/user/login'
        } else if(window.location.host === 'ningbo.dtwl360.com') {
          window.location.href = 'https://ningbo.dtwl360.com/adm/user/login'
        } else if(window.location.host === 'jiangsu.dtwl360.com') {
          window.location.href = 'https://jiangsu.dtwl360.com/adm/user/login'
        } else if(window.location.host === 'xinjiang.dtwl360.com') {
          window.location.href = 'https://xinjiang.dtwl360.com/adm/user/login'
        } else if(window.location.host === 'guangdong.dtwl360.com') {
          window.location.href = 'https://guangdong.dtwl360.com/adm/user/login'
        } else if(window.location.host === 'zhejiang.dtwl360.com') {
          window.location.href = 'https://zhejiang.dtwl360.com/adm/user/login'
        } else if(window.location.host === 'tianjin.dtwl360.com') {
          window.location.href = 'https://tianjin.dtwl360.com/adm/user/login'
        } else if(window.location.host === 'guangxi.dtwl360.com') {
          window.location.href = 'https://guangxi.dtwl360.com/adm/user/login'
        } else if(window.location.host === 'hubei.dtwl360.com') {
          window.location.href = 'https://hubei.dtwl360.com/adm/user/login'
        } else if(window.location.host === 'anhui.dtwl360.com') {
          window.location.href = 'https://anhui.dtwl360.com/adm/user/login'
        } else if(window.location.host === 'qinghai.dtwl360.com') {
          window.location.href = 'https://qinghai.dtwl360.com/adm/user/login'
        } else if(window.location.host === 'bdh.dtwl360.com') {
          window.location.href = 'https://bdh.dtwl360.com/adm/user/login'
        } else if(window.location.host === 'sichuan.dtwl360.com') {
          window.location.href = 'https://sichuan.dtwl360.com/adm/user/login'
        } else if(window.location.host === 'huaxia.dtwl360.com') {
          window.location.href = 'https://huaxia.dtwl360.com/adm/user/login'
        } else if(window.location.host === 'sx.dtwl360.com') {
          window.location.href = 'https://sx.dtwl360.com/adm/user/login'
        } else if(window.location.host === 'liaoning.dtwl360.com') {
          window.location.href = 'https://liaoning.dtwl360.com/adm/user/login'
        } else if(window.location.host === 'yunnan.dtwl360.com') {
          window.location.href = 'https://yunnan.dtwl360.com/adm/user/login'
        } else {
          this.$router.push({
            path: "/Login"
          })
        }
      })
    },
    // 跳转控制台
    goadmin() {
      var host = window.location.host
      if(host === "beijing.dtwl360.com") {
        var token = localStorage.getItem("token");
        const targetWindow = window.open("https://beijing.dtwl360.com/adm/manage/center", '_self');
        setTimeout(() => {
          targetWindow.postMessage(token, "https://beijing.dtwl360.com/adm/manage/center");
        }, 3000);
      } else if(host === "hebei.dtwl360.com") {
        var token = localStorage.getItem("token");
        const targetWindow = window.open("https://hebei.dtwl360.com/adm/manage/center", '_self');
        setTimeout(() => {
          targetWindow.postMessage(token, "https://hebei.dtwl360.com/adm/manage/center");
        }, 3000);
      } else if(host === "hunan.dtwl360.com") {
        var token = localStorage.getItem("token");
        const targetWindow = window.open("https://hunan.dtwl360.com/adm/manage/center", '_self');
        setTimeout(() => {
          targetWindow.postMessage(token, "https://hunan.dtwl360.com/adm/manage/center");
        }, 3000);
      } else if(host === "neimeng.dtwl360.com") {
        var token = localStorage.getItem("token");
        const targetWindow = window.open("https://neimeng.dtwl360.com/adm/manage/center", '_self');
        setTimeout(() => {
          targetWindow.postMessage(token, "https://neimeng.dtwl360.com/adm/manage/center");
        }, 3000);
      } else if(host === "xiamen.dtwl360.com") {
        var token = localStorage.getItem("token");
        const targetWindow = window.open("https://xiamen.dtwl360.com/adm/manage/center", '_self');
        setTimeout(() => {
          targetWindow.postMessage(token, "https://xiamen.dtwl360.com/adm/manage/center");
        }, 3000);
      } else if(host === "hubei.dtwl360.com") {
        var token = localStorage.getItem("token");
        const targetWindow = window.open("https://hubei.dtwl360.com/adm/manage/center", '_self');
        setTimeout(() => {
          targetWindow.postMessage(token, "https://hubei.dtwl360.com/adm/manage/center");
        }, 3000);
      } else if(host === 'ningbo.dtwl360.com') {
        var token = localStorage.getItem('token')
        const targetWindow = window.open('https://ningbo.dtwl360.com/adm/manage/center', '_self');
        setTimeout(() => {
          targetWindow.postMessage(token, 'https://ningbo.dtwl360.com/adm/manage/center')
        }, 3000)
      } else if(host === 'gansu.dtwl360.com') {
        var token = localStorage.getItem('token')
        const targetWindow = window.open('https://gansu.dtwl360.com/adm/manage/center', '_self');
        setTimeout(() => {
          targetWindow.postMessage(token, 'https://gansu.dtwl360.com/adm/manage/center')
        }, 3000)
      } else if(host === 'qinghai.dtwl360.com') {
        var token = localStorage.getItem('token')
        const targetWindow = window.open('https://qinghai.dtwl360.com/adm/manage/center', '_self');
        setTimeout(() => {
          targetWindow.postMessage(token, 'https://qinghai.dtwl360.com/adm/manage/center')
        }, 3000)
      } else if(host === 'bdh.dtwl360.com') {
        var token = localStorage.getItem('token')
        const targetWindow = window.open('https://bdh.dtwl360.com/adm/manage/center', '_self');
        setTimeout(() => {
          targetWindow.postMessage(token, 'https://bdh.dtwl360.com/adm/manage/center')
        }, 3000)
      } else if(host === 'anhui.dtwl360.com') {
        var token = localStorage.getItem('token')
        const targetWindow = window.open('https://anhui.dtwl360.com/adm/manage/center', '_self');
        setTimeout(() => {
          targetWindow.postMessage(token, 'https://anhui.dtwl360.com/adm/manage/center')
        }, 3000)
      } else if(host === 'jiangsu.dtwl360.com') {
        var token = localStorage.getItem('token')
        const targetWindow = window.open('https://jiangsu.dtwl360.com/adm/manage/center', '_self');
        setTimeout(() => {
          targetWindow.postMessage(token, 'https://jiangsu.dtwl360.com/adm/manage/center')
        }, 3000)
      } else if(host === 'xinjiang.dtwl360.com') {
        var token = localStorage.getItem('token')
        const targetWindow = window.open('https://xinjiang.dtwl360.com/adm/manage/center', '_self');
        setTimeout(() => {
          targetWindow.postMessage(token, 'https://xinjiang.dtwl360.com/adm/manage/center')
        }, 3000)
      } else if(host === 'xjbt.dtwl360.com') {
        var token = localStorage.getItem('token')
        const targetWindow = window.open('https://xjbt.dtwl360.com/adm/manage/center', '_self');
        setTimeout(() => {
          targetWindow.postMessage(token, 'https://xjbt.dtwl360.com/adm/manage/center')
        }, 3000)
      } else if(host === 'guangdong.dtwl360.com') {
        var token = localStorage.getItem('token')
        const targetWindow = window.open('https://guangdong.dtwl360.com/adm/manage/center', '_self');
        setTimeout(() => {
          targetWindow.postMessage(token, 'https://guangdong.dtwl360.com/adm/manage/center')
        }, 3000)
      } else if(host === 'qingdao.dtwl360.com') {
        var token = localStorage.getItem('token')
        const targetWindow = window.open('https://qingdao.dtwl360.com/adm/manage/center', '_self');
        setTimeout(() => {
          targetWindow.postMessage(token, 'https://qingdao.dtwl360.com/adm/manage/center')
        }, 3000)
      } else if(host === 'jiangxi.dtwl360.com') {
        var token = localStorage.getItem('token')
        const targetWindow = window.open('https://jiangxi.dtwl360.com/adm/manage/center', '_self');
        setTimeout(() => {
          targetWindow.postMessage(token, 'https://jiangxi.dtwl360.com/adm/manage/center')
        }, 3000)
      } else if(host === 'shandong.dtwl360.com') {
        var token = localStorage.getItem('token')
        const targetWindow = window.open('https://shandong.dtwl360.com/adm/manage/center', '_self');
        setTimeout(() => {
          targetWindow.postMessage(token, 'https://shandong.dtwl360.com/adm/manage/center')
        }, 3000)
      } else if(host === 'ningxia.dtwl360.com') {
        var token = localStorage.getItem('token')
        const targetWindow = window.open('https://ningxia.dtwl360.com/adm/manage/center', '_self');
        setTimeout(() => {
          targetWindow.postMessage(token, 'https://ningxia.dtwl360.com/adm/manage/center')
        }, 3000)
      } else if(host === 'chongqing.dtwl360.com') {
        var token = localStorage.getItem('token')
        const targetWindow = window.open('https://chongqing.dtwl360.com/adm/manage/center', '_self');
        setTimeout(() => {
          targetWindow.postMessage(token, 'https://chongqing.dtwl360.com/adm/manage/center')
        }, 3000)
      } else if(host === 'fujian.dtwl360.com') {
        var token = localStorage.getItem('token')
        const targetWindow = window.open('https://fujian.dtwl360.com/adm/manage/center', '_self');
        setTimeout(() => {
          targetWindow.postMessage(token, 'https://fujian.dtwl360.com/adm/manage/center')
        }, 3000)
      } else if(host === 'zhejiang.dtwl360.com') {
        var token = localStorage.getItem('token')
        const targetWindow = window.open('https://zhejiang.dtwl360.com/adm/manage/center', '_self');
        setTimeout(() => {
          targetWindow.postMessage(token, 'https://zhejiang.dtwl360.com/adm/manage/center')
        }, 3000)
      } else if(host === 'tianjin.dtwl360.com') {
        var token = localStorage.getItem('token')
        const targetWindow = window.open('https://tianjin.dtwl360.com/adm/manage/center', '_self');
        setTimeout(() => {
          targetWindow.postMessage(token, 'https://tianjin.dtwl360.com/adm/manage/center')
        }, 3000)
      } else if(host === 'guangxi.dtwl360.com') {
        var token = localStorage.getItem('token')
        const targetWindow = window.open('https://guangxi.dtwl360.com/adm/manage/center', '_self');
        setTimeout(() => {
          targetWindow.postMessage(token, 'https://guangxi.dtwl360.com/adm/manage/center')
        }, 3000)
      } else if(host === 'taiwan.dtwl360.com') {
        var token = localStorage.getItem('token')
        const targetWindow = window.open('https://taiwan.dtwl360.com/adm/manage/center', '_self');
        setTimeout(() => {
          targetWindow.postMessage(token, 'https://taiwan.dtwl360.com/adm/manage/center')
        }, 3000)
      } else if(host === 'henan.dtwl360.com') {
        var token = localStorage.getItem('token')
        const targetWindow = window.open('https://henan.dtwl360.com/adm/manage/center', '_self');
        setTimeout(() => {
          targetWindow.postMessage(token, 'https://henan.dtwl360.com/adm/manage/center')
        }, 3000)
      } else if(host === 'national.dtwl360.com') {
        var token = localStorage.getItem('token')
        const targetWindow = window.open('https://national.dtwl360.com/adm/manage/center', '_self');
        setTimeout(() => {
          targetWindow.postMessage(token, 'https://national.dtwl360.com/adm/manage/center')
        }, 3000)
      } else if(host === 'sichuan.dtwl360.com') {
        var token = localStorage.getItem('token')
        const targetWindow = window.open('https://sichuan.dtwl360.com/adm/manage/center', '_self');
        setTimeout(() => {
          targetWindow.postMessage(token, 'https://sichuan.dtwl360.com/adm/manage/center')
        }, 3000)
      } else if(host === 'huaxia.dtwl360.com') {
        var token = localStorage.getItem('token')
        const targetWindow = window.open('https://huaxia.dtwl360.com/adm/manage/center', '_self');
        setTimeout(() => {
          targetWindow.postMessage(token, 'https://huaxia.dtwl360.com/adm/manage/center')
        }, 3000)
      } else if(host === 'sx.dtwl360.com') {
        var token = localStorage.getItem('token')
        const targetWindow = window.open('https://sx.dtwl360.com/adm/manage/center', '_self');
        setTimeout(() => {
          targetWindow.postMessage(token, 'https://sx.dtwl360.com/adm/manage/center')
        }, 3000)
      } else if(host === 'liaoning.dtwl360.com') {
        var token = localStorage.getItem('token')
        const targetWindow = window.open('https://liaoning.dtwl360.com/adm/manage/center', '_self');
        setTimeout(() => {
          targetWindow.postMessage(token, 'https://liaoning.dtwl360.com/adm/manage/center')
        }, 3000)
      } else if(host === 'yunnan.dtwl360.com') {
        var token = localStorage.getItem('token')
        const targetWindow = window.open('https://yunnan.dtwl360.com/adm/manage/center', '_self');
        setTimeout(() => {
          targetWindow.postMessage(token, 'https://yunnan.dtwl360.com/adm/manage/center')
        }, 3000)
      }
    },
    subsidies() {
      this.$router.push("/positioning-monitor")
    },
    handleClose(done) {
      this.dialogVisible = false
    }
  }
}
</script>
<style scoped>
	.el-menu {
		position: unset;
	}
	
	.el-menu.el-menu--horizontal {
		border-bottom: none!important;
	}
	
	.el-popper {
		margin-top: 0!important;
		/* top: 60px!important; */
	}
	
	.el-menu.el-menu--horizontal,
	.el-menu--horizontal>.el-menu-item.is-active {
		border-bottom: 0;
	}
	
	.el-menu-item:focus,
	.el-menu-item:hover,
	.el-menu--horizontal>.el-menu-item:not(.is-disabled):focus,
	.el-menu--horizontal>.el-menu-item:not(.is-disabled):hover,
	.el-menu--horizontal>.el-submenu .el-submenu__title:hover {
		background-color: transparent;
	}
	
	.el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
	.el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
		color: #fff;
	}
	
	.header {
		height: 9vh;
		width: 100%;
		background: #032285;
		background-image: url("/static/img/head2.png");
		background-size: 100% 100%;
		position: relative;
	}
	
	.header_title span {
		font-size: 2.2vw;
		-webkit-line-clamp: 2;
		background-image: -webkit-linear-gradient( bottom, #bee9ff, #cceeff, #dbf3ff, #f1fbff, #ffffff);
		background: -o-linear-gradient( bottom, #bee9ff, #cceeff, #dbf3ff, #f1fbff, #ffffff);
		background: linear-gradient( bottom, #bee9ff, #cceeff, #dbf3ff, #f1fbff, #ffffff);
		background-clip: text;
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
		font-family: "微软雅黑";
		font-weight: bold;
		color: #dbf3ff;
		line-height: 7.6vh;
	}
	
	.header_title img {
		width: 3vw;
		/* height: 2.6vw; */
		vertical-align: middle;
		padding-bottom: 1vw;
	}
	
	.nav {
		position: absolute;
		left: 0;
		top: 0;
		/* display: flex; */
		height: 5vw;
		line-height: 5vw;
		/* width: 23%; */
		width: 93%;
		display: flex;
		justify-content: space-between;
	}
	/* .el-menu-item:nth-child(1){
    width: 35%;
    height: 4.3vw;
		line-height: 4.3vw;
  }
  .el-menu-item:nth-child(2){
    width: 24%;
    height: 4.3vw;
		line-height: 4.3vw;
  } */
	
	.el-menu-item {
		height: 4.8vw;
		line-height: 4.8vw;
	}
	
	.nav div {
		/* width: 50%; */
		width: 10%;
		cursor: pointer;
	}
	
	.nav div:nth-child(1) {
		float: left;
		margin-left: 12vw;
	}
	
	.nav div:nth-child(2) {
		float: right;
		margin-right: 5vw;
	}
	
	.nav img {
		width: 1.4vw;
		/*height: 1.3vw;*/
		vertical-align: middle;
		/* padding-bottom: 0.5vw; */
	}
	
	.nav div:nth-child(4) img {
		width: 1.1vw;
		height: 1vw;
		vertical-align: middle;
		padding-bottom: 0.5vw;
	}
	
	.nav span {
		color: #c0d6ff;
		font-size: 24px;
	}
	
	.nav_items0 {
		background: url('/static/img/nongji-icon2.png') no-repeat 0% center;
		background-size: 1.4vw;
	}
	
	.nav_items0.active {
		background: url('/static/img/nongjidashuju.png') no-repeat 0% center;
		background-size: 1.4vw;
	}
	
	.nav_items1 {
		background: url('/static/img/nongjisanheyi.png') no-repeat 0% center;
		background-size: 1.4vw;
	}
	
	.nav_items1.active {
		background: url('/static/img/nongji-icon.png') no-repeat 0% center;
		background-size: 1.4vw;
	}
	
	.nav_items2 {
		background: url('/static/img/head/yingyong_icon.png') no-repeat 0% center;
		background-size: 1.3vw;
	}
	
	.nav_items2.active {
		background: url('/static/img/head/yingyong_on_icon.png') no-repeat 0% center;
		background-size: 1.3vw;
	}
	
	.nav_items3,
	.nav_items5 {
		background: url('/static/img/head/daikuan_icon.png') no-repeat 0% center;
		background-size: 1.2vw;
	}
	
	.nav_items3.active,
	.nav_items5.active {
		background: url('/static/img/head/daikuan_on_icon.png') no-repeat 0% center;
		background-size: 1.2vw;
	}
	
	.nav_items4 {
		background: url('/static/img/data_zytj.png') no-repeat 0% center;
		background-size: 1.3vw;
	}
	
	.nav_items4.active {
		background: url('/static/img/data_zytj0.png') no-repeat 0% center;
		background-size: 1.3vw;
	}
	
	.active span {
		font-weight: bold;
		color: #ffffff !important;
	}
	
	.nav_hunan {
		position: absolute;
		left: 0;
		top: 0;
		/* display: flex; */
		height: 5vw;
		line-height: 5vw;
		/* width: 23%; */
		width: 93%;
		justify-content: space-between;
	}
	
	.nav_hunan div {
		/* width: 50%; */
		width: 10%;
		cursor: pointer;
	}
	
	.nav_hunan div:nth-child(1),
	.nav_hunan div:nth-child(2) {
		float: left;
		margin-left: 3vw;
	}
	
	.nav_hunan div:nth-child(3) {
		width: 8%;
		margin-left: 50vw;
		float: left;
	}
	
	.nav_hunan div:nth-child(4) {
		width: 10%;
		margin-left: 0.7vw;
		float: left;
	}
	
	.nav_hunan img {
		width: 1.3vw;
		height: 1.2vw;
		vertical-align: middle;
		padding-bottom: 0.5vw;
	}
	
	.nav_hunan div:nth-child(4) img {
		width: 1.1vw;
		height: 1vw;
		vertical-align: middle;
		padding-bottom: 0.5vw;
	}
	
	.nav_hunan span {
		color: #c0d6ff;
		font-size: 1.1vw;
	}
	
	.header_right {
		display: flex;
		position: absolute;
		right: 0;
		top: 30px;
		/* line-height: 5vw; */
	}
	
	.header_right span {
		color: #c0d6ff;
		font-size: 0.8vw;
	}
	
	.header_right div {
		margin-right: 1vw;
	}
	
	.header_right .areaName img {
		width: 0.8vw;
		height: 1vw;
		vertical-align: middle;
		padding-bottom: 0.4vw;
	}
	
	.header_right .goadmin img {
		width: 23px;
		height: 20px;
		vertical-align: middle;
		padding-bottom: 0.2vw;
	}
	
	.header_right .loginOut img {
		width: 1.4vw;
		height: 1.4vw;
		vertical-align: middle;
		padding-bottom: 0.5vw;
	}
	
	.el-dropdown-link {
		cursor: pointer;
		color: #409eff;
	}
	
	.el-icon-arrow-down {
		font-size: 12px;
	}
	
	.demonstration {
		display: block;
		color: #8492a6;
		font-size: 14px;
		margin-bottom: 20px;
	}
</style>


// WEBPACK FOOTER //
// src/components/Index/common/Header.vue